import { ReactNode, createContext, useContext, useState } from "react";
import { Image } from "antd";
import { toast } from "react-toastify";
import copy from "copy-to-clipboard";
import {
  AptosIcon,
  BaseIcon,
  BinanceNewIcon,
  EthIcon,
  ICPIcon,
  SolanaIcon,
  SuiIcon,
  USDTIcon,
  VenomIcon,
} from "svgIcon";
import IOTAIcon from "assets/images/IOTA.svg";
import TronIcon from "assets/images/tron.png";

export const emailValidationExp = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);

export const numericValidationExp = new RegExp(/^-?\d*\.?\d*$/);

export const digitValidationExp = new RegExp(/^[0-9]+/);

export const ChainSUI = "SUI";
export const ChainSuiCoin = "SUI COIN";
export const ChainSuiFud = "FUD";
export const ChainSuiFlowx = "FlowX";
export const ChainSuiUsdc = "USDC";
export const ChainSuiSacabam = "Sacabam";
export const ChainSuiNavx = "NAVX";
export const ChainAptos = "Aptos";
export const ChainVenom = "Venom";
export const ChainSolana = "Solana";
export const ChainSOL = "SOL";
export const ChainSolanaUSDC = "SOL-USDC";
export const ChainSolanaJUP = "JUP";
export const ChainICP = "ICP";
export const ChainInternetCP = "Internet Computer";
export const ChainCKBTC = "ckBTC";
export const ChainCKETH = "ckETH";
export const ChainCKTestBTC = "ckTESTBTC";

export const usdCurrency = "USD";
export const euroCurrency = "EUR";

export const StatusCompleted = "completed";
export const StatusPending = "pending";

export const TypePOS = "POS";
export const TypeEcommerce = "Ecommerce";

export const POSFlow = "pos";
export const EcommerceFlow = "ecommerce";
export const SuiFrensFlow = "sfrens";
export const ExclusiveFlow = "exclusive";

export const POSTheme = "pos";
export const BasicTheme = "Basic Layout";
export const StandardTheme = "Standard Layout";
export const ExclusiveTheme = "Exclusive Layout";
export const SuiFrensTheme = "SuiFrens Layout";

export const POS_DEVICE_WIDTH = 1366
export const POS_DEVICE_HEIGHT = 696

export const checkAllRequiredFieldsWithKey = (fields: any, values: any) =>
  Object.entries(fields).reduce((acc, [key]) => {
    const message = !values[key] ? "This field is required" : "";
    return { ...acc, [key]: message };
  }, {});

export const setStorageData = (key: any, data: any) => {
  // const dataTemp = JSON.stringify(data);
  localStorage.setItem(key, data);
};

export const getStorageData = (key: string) => {
  try {
    const item = localStorage.getItem(key);
    if (item !== null) {
      return item;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

export function hasDoubleSlashes(pathname: any) {
  const regex = /^\/[^\/]+\/[^\/]+/; // Regex to check for two segments in the pathname
  return regex.test(pathname);
}

export function getFirstSegment(pathname: any) {
  const segments = pathname.split('/').filter((segment: any) => segment);
  return segments[0]; // Return the first segment
}

export function getSecondSegment(pathname: any) {
  const segments = pathname.split('/').filter((segment: any) => segment);
  return segments[1]; // Return the first segment
}

export function extractID(str: any) {
  const match = str.match(/(pos|paylink|sell|ecommerce)=(\d+)/);
  if (match) {
    const [, name, id] = match; // Destructuring the matched array
    return { name, id };
  }
  return null;
}

export const decodeContent = (pos: string) => {
  return atob(pos); // Use btoa to base64 encode the string
};

export const encodeContent = (pos: string) => {
  return btoa(pos);
};

export function shortenValue(value: any): any {
  return parseFloat(value.toFixed(4));
}

export const dateAndTimeFormat = () => {
  const timestamp = Date.now();
  const humanReadableDate = new Date(timestamp).toLocaleString("sv-SE", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  return humanReadableDate;
};

export const copyContent = (textToCopy: string) => {
  copy(textToCopy, {
    debug: true,
    message: "Press #{key} to copy",
  });
  toastMessage("Copied!");
};

export const onPhoneNumberVerify = (getValue: any) => {
  if (!numericValidationExp.test(getValue)) {
    return { status: false, message: "Contact should be in an integer" };
  }
  if (getValue.length !== 10) {
    return { status: false, message: "Contact number are invalid" };
  }
  if (getValue.length > 10) {
    return { status: false, message: "Contact number are invalid" };
  }
  return { status: true, message: "" };
}

export const onZipNumberVerify = (getValue: any) => {
  if (!numericValidationExp.test(getValue)) {
    return { status: false, message: "Zip code should be in an integer" };
  }
  if (getValue.length < 5) {
    return { status: false, message: "Zip code are invalid" };
  }
  return { status: true, message: "" };
}

export const onEmailAddressVerify = (getValue: any) => {
  if (!emailValidationExp.test(getValue)) {
    return { status: false, message: "Please enter a valid email properly" };
  }
  return { status: true, message: "" };
}

export const identifySuiDecimal = (getCoinName: any) => {
  switch (getCoinName) {
    case "FUD": {
      return 1_00_000;
    }
    case "FlowX": {
      return 1_00_000_000;
    }
    case "SUI COIN": {
      return 1_000_000_000;
    }
    case "USDC": {
      return 1_000_000;
    }
    case "Sacabam": {
      return 1_000_00;
    }
    case "NAVX": {
      return 1_000_000_000;
    }
    case "SUI": {
      return 1_000_000_000;
    }
    default: {
      return 1_000_000_000;
    }
  }
};

export const selectedChainIcon = (getCoinName: any) => {
  switch (getCoinName) {
    case "SUI COIN": {
      return <SuiIcon />;
    }
    case "SUI": {
      return <SuiIcon />;
    }
    case "Aptos": {
      return <AptosIcon />;
    }
    case "Venom": {
      return <VenomIcon />;
    }
    case "Solana": {
      return <SolanaIcon />;
    }
    case "SOL": {
      return <SolanaIcon />;
    }
    case "ICP": {
      return <ICPIcon />;
    }
    case "Internet Computer": {
      return <ICPIcon />;
    }
    case "BNB": {
      return <BinanceNewIcon />;
    }
    case "Binance": {
      return <BinanceNewIcon />;
    }
    case "BNB COIN": {
      return <BinanceNewIcon />;
    }
    case "BASE": {
      return <BaseIcon />;
    }
    case "ETH COIN": {
      return <EthIcon />;
    }
    case "ETH": {
      return <EthIcon />;
    }
    case "Internet of things": {
      return <Image src={IOTAIcon} preview={false} />;
    }
    case "IOTA": {
      return <Image src={IOTAIcon} preview={false} />;
    }
    case "IOTA COIN": {
      return <Image src={IOTAIcon} preview={false} />;
    }
    case "TRON": {
      return <Image src={TronIcon} preview={false} />;
    }
    case "TRON-USDT": {
      return <USDTIcon />;
    }
  }
};

export const toastMessage = (data: any) =>
  toast(data, {
    position: "top-left",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });

export function shortenAddress(
  text: string,
  start = 5,
  end = 3,
  separator = "..."
): string {
  return !text
    ? ""
    : text.slice(0, start) + separator + (end ? text.slice(-end) : "");
}

interface GlobalMerchantContextType {
  globalMerchantId: string | null;
  setGlobalMerchantId: (merchantId: string | null) => void;
  paymentIframeURL: string | null;
  setPaymentIframeURL: (paymentUrl: string | null) => void;
  globalMerchantCurrency: string;
  setGlobalMerchantCurrency: (merchantRole: string) => void;
  productContent: any;
  setProductContent: (content: any) => void;
  ecommerceContent: any;
  setEcommerceContent: (content: any) => void;
  isEndsWithSlash: any;
  setIsEndsWithSlash: (content: any) => void;
  themeName: any;
  setThemeName: (content: any) => void;
}

const GlobalMerchantContext = createContext<GlobalMerchantContextType | undefined>(undefined);

export function GlobalMerchantProvider({ children }: { children: ReactNode }) {
  const [globalMerchantId, setGlobalMerchantId] = useState<string | null>(null);
  const [paymentIframeURL, setPaymentIframeURL] = useState<string | null>(null);
  const [globalMerchantCurrency, setGlobalMerchantCurrency] = useState<string>(usdCurrency);
  const [ecommerceContent, setEcommerceContent] = useState<any>({});
  const [productContent, setProductContent] = useState<any>({});
  const [isEndsWithSlash, setIsEndsWithSlash] = useState(false);
  const [themeName, setThemeName] = useState("");

  return (
    <GlobalMerchantContext.Provider
      value={{
        globalMerchantId,
        setGlobalMerchantId,
        paymentIframeURL,
        setPaymentIframeURL,
        globalMerchantCurrency,
        setGlobalMerchantCurrency,
        productContent,
        setProductContent,
        ecommerceContent,
        setEcommerceContent,
        isEndsWithSlash,
        setIsEndsWithSlash,
        themeName,
        setThemeName
      }}
    >
      {children}
    </GlobalMerchantContext.Provider>
  );
}

export function useGlobalMerchant() {
  const context = useContext(GlobalMerchantContext);
  if (context === undefined) {
    throw new Error('useGlobalMerchant must be used within a GlobalMerchantProvider');
  }
  return context;
}